import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthHeader from './AuthHeader/AuthHeader';
import TopBar from './TopBar/TopBar';

const AuthLayout = () => {
  return (
    <div className="auth-layout-container">
      <TopBar/>
      <AuthHeader />
      {/* Wrapper ini akan memastikan form tetap di tengah */}
      <div className="auth-content-wrapper">
        <Outlet /> 
      </div>
    </div>
  );
};

export default AuthLayout;